import React, { Component, Fragment } from 'react';
import { Button, Header, Icon, Loader, Segment, SegmentGroup } from 'semantic-ui-react';
import { FiltersOnStyle, IconHeader } from '../util/css';
import NewResource from '../Resources/NewResource';
import ResourceList from '../Resources/ResourceList';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import {FACULTY_ADMIN, fetchActiveRole, fetchUserOrganizationalUnit} from '../util/roles';
import { checkFaculty, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE, getTotalNumberOfPages } from '../util/util';
import RoomList from './RoomList';
import NewRoom from './NewRoom';
import PaginationSegment from '../util/PaginationSegment';

class Rooms extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            rooms: [],
            openNewRoom: false,
            activePage: 1,
            totalPages: 1,
            resultsPerPage: DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,
            filterRequestData: null,
            loader: true
        };
        this.getUserData = this.getUserData.bind(this);
        this.fetchAllRooms = this.fetchAllRooms.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.updateRooms = this.updateRooms.bind(this);
        this.getWritePrivilege = this.getWritePrivilege.bind(this);
    }

    componentDidMount() {
        this.getUserData();
    }

    getUserData() {
        axios.all([fetchActiveRole(), fetchUserOrganizationalUnit()])
            .then(axios.spread((activeRoleRes, userOrganizationalUnitRes) => {
                const activeRole = activeRoleRes.data;
                const organizationalUnitId = userOrganizationalUnitRes.data;
                this.setState({ activeRole, organizationalUnitId });
                if (checkFaculty(activeRole)) {
                    this.fetchAllRooms();
                } else {
                    this.fetchAllRooms();
                }
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch data.');
            });
    }

    fetchAllRooms(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        this.fetchRooms(page, resultsPerPage).then((res) => {
            const rooms = res.data.responseList;
            let totalPages = getTotalNumberOfPages(res.data.total, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE);
            this.setState({ rooms, totalPages, loader: false });
            this.updateRooms(page, resultsPerPage, res);
        });
    }

    fetchRooms(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        const pagination = {
            page,
            resultsPerPage,
        };
        return axios.post('/assets/rooms/paginated/', { ...pagination });
    }

    handlePageChange(e, { activePage }) {
        if (activePage === this.state.activePage) {
            return;
        }

        if (this.state.showFiltersOnButton) {
            this.getFilteredRooms(activePage - 1, this.state.resultsPerPage);
        } else {
            this.fetchAllRooms(activePage - 1, this.state.resultsPerPage);
        }
    }

    updateRooms(page, resultsPerPage, res) {
        let totalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);

        this.setState(prevState => ({
            activePage: page + 1,
            resultsPerPage,
            totalPages
        }));
    }
    getWritePrivilege() {
        const activeRole = localStorage.getItem('activeRole');
        if (activeRole === FACULTY_ADMIN || activeRole.substr(0, 18) === FACULTY_ADMIN) {
            return true;
        }
        return false;
    }

    render() {
        const { rooms } = this.state;
        const writePrivilege = this.getWritePrivilege();
        return (
            <div>
                <Header as="h1">Prostorije</Header>
                <SegmentGroup raised>
                    <Segment>
                        <Header as="h3">
                            Spisak prostorija
                            {writePrivilege &&
                            <Header style={IconHeader} floated="right"> <Button
                                color="blue"
                                floated="right"
                                icon
                                labelPosition="right"
                                size="small"
                                style={FiltersOnStyle}
                                onClick={() => this.setState({ openNewRoom: true })}
                            ><Icon className="add" />
                                Dodavanje prostorije
                            </Button>
                            </Header>
                            }

                        </Header>
                    </Segment>
                    <Segment>
                        {this.state.openNewRoom && <NewRoom
                            organizationalUnitId={this.state.organizationalUnitId}
                            activeRole={this.state.activeRole}
                            fetchAllRooms={this.fetchAllRooms}
                            closeForm={() => this.setState({ openNewRoom: false })}
                        />}
                        {this.state.loader ?
                            <Loader active inline="centered" />
                            : rooms && rooms.length ?
                                <Fragment>
                                    <RoomList
                                        rooms={rooms}
                                        activateEditRequest={this.activateEditRequest}
                                    />
                                    <PaginationSegment
                                        activePage={this.state.activePage}
                                        totalPages={this.state.totalPages}
                                        onPageChange={this.handlePageChange}
                                    />
                                </Fragment>

                                : 'Nema podataka o opremi.'
                        }

                    </Segment>
                </SegmentGroup>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

export default Rooms;



// WEBPACK FOOTER //
// ./src/views/Assets/Rooms/Rooms.js